import { Space, Tag, Tooltip, Typography } from 'antd'
import { InvoiceableWorkarea } from '../../../domain/invoicing/invoice'

type Props = { workareas: InvoiceableWorkarea[] }

const InvoiceableWorkareaPills = ({ workareas }: Props) => <Space size={4} wrap>
  {workareas.slice(0, 3).map(workarea => <Tag key={workarea.id} style={{ marginRight: 0 }}>
    <Typography.Text ellipsis={{ tooltip: workarea.name }} style={{ maxWidth: 140, fontSize: 'inherit' }}>
      {workarea.name}
    </Typography.Text>
  </Tag>)}
  {workareas.length > 3 && <Tooltip title={<div>
    {workareas.slice(3).map(workarea => <div key={workarea.id}>{workarea.name}</div>)}
  </div>}>
    <Tag tabIndex={0}>+{workareas.length - 3}</Tag>
  </Tooltip>}
</Space>

export default InvoiceableWorkareaPills
